import { ACTION_TYPES } from './store/actions';
import { contractApi } from '../api';
import { IContract } from '../model/search.model';
import { IUserInfo } from '../model/userInfo.model';
import { RulesKeys } from 'app/modules/rules/domain/rules.keys';
import { routerHistory } from 'app/shared/config/store';

// récuperer les dossiers liés a une adhésions
export const getClaimsSubscriptionByNumber = (subNumber: string) => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.GET_CLAIMS_SUBSCRIPTION_BY_NUMBER,
    payload: contractApi.getClaimsSubscriptionByNumber(subNumber),
  });
};

// ce service regroupe 2 services utulisé dans krys && BT
export const getSubscriptionAndOffer = (subNumber: string) => async (dispatch, getState) => {
  // 1=> récuperer les détails de l'adhésion (infos Client,BankingInfo,Produit assuré)

  const { checkUserAttribute } = await getState().rules.dataConfList.get(RulesKeys.GET_CONF);

  await dispatch({
    type: ACTION_TYPES.GET_SUBSCRIPTION_BY_NUMBER,
    payload: contractApi.getSubscriptionByNumber(subNumber, checkUserAttribute),
  });

  // 2=> récuperer Montant de la cotisation selon le code produit
  const { subscriptionModel } = await getState().contract;
  await dispatch({
    type: ACTION_TYPES.GET_PRODUCT_OFFRE,
    payload: contractApi.getProductOffreByNumber(subscriptionModel.subscriptionSelected.offerCodes[0]),
  });

  await dispatch({
    type: ACTION_TYPES.GET_CONTRACTUEL_DOCUMENTS,
    payload: contractApi.getContractualDocument(subscriptionModel.subscriptionSelected.offerCodes[0]),
  });
};

export const getContractualDocument = offre => async (dispatch, getState) => {
  await dispatch({
    type: ACTION_TYPES.GET_CONTRACTUEL_DOCUMENTS,
    payload: contractApi.getContractualDocument(offre),
  });
};

// récuperer La liste des adhésion selon la recherche fait par (Email/FirstName,LasteName/subscription|ClaimNumber)
export const getSubscriptionByClient = (client: IContract) => async (dispatch, getState) => {
  await dispatch({
    type: ACTION_TYPES.GET_SUBSCRIPTION_BY_CLIENT,
    payload: contractApi.getSubscriptionByClient(client),
  });

  if (client.verifList) {
    client.verifList(await getState().contract.subscriptionList, routerHistory);
  }
};

// récuperer La liste des adhésion Active par identifiant SSO
export const getActiveSubscriptionByClient = () => async (dispatch, getState) => {
  await dispatch({
    type: ACTION_TYPES.GET_SUBSCRIPTION_BY_CLIENT,
    payload: contractApi.getActiveSubscriptionByClient(),
  });
};

// récuperer La liste des adhésion
export const getAllSubscriptionByClient = (client: IContract) => async (dispatch, getState) => {
  await dispatch({
    type: ACTION_TYPES.GET_SUBSCRIPTION_BY_CLIENT,
    payload: contractApi.getAllSubscriptionByClient(client),
  });
};

// Faire la mise à jour des infos client
export const updateUserInfo = (userInfo: IUserInfo, subscriptionNumber: string) => async (dispatch, getState) => {
  await dispatch({
    type: ACTION_TYPES.UPDATE_INFO_CLIENT,
    payload: contractApi.updateUserInfo(userInfo, subscriptionNumber),
  });
  const { updated } = await getState().contract;
  if (updated === true) {
    await dispatch({
      type: ACTION_TYPES.RESET_USER_INFO,
    });
  }
};

// afficher la pagination des adhésions
export const setPage = (page: number) => dispatch => {
  dispatch({
    type: ACTION_TYPES.SET_PAGE,
    payload: { page },
  });
};

// Réinitialiser la recherche des adhésions
export const resetContract = () => dispatch => {
  dispatch({
    type: ACTION_TYPES.RESET_CONTRACT,
    payload: [],
  });
};

export const resetUserInfo = () => dispatch => {
  dispatch({
    type: ACTION_TYPES.RESET_USER_INFO,
  });
};

// oui
export const getListImpayeInfo = (number: string) => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.GET_LIST_IMPYE_INFO,
    payload: contractApi.getListImpayeInfo(number),
  });
};

// oui
export const getOffer = (offer: string) => async (dispatch, getState) => {
  // 2=> récuperer Montant de la cotisation selon le code produit
  const { subscriptionModel } = await getState().contract;
  await dispatch({
    type: ACTION_TYPES.GET_PRODUCT_OFFRE,
    payload: contractApi.getProductOffreByNumber(offer),
  });
};

// oui
export const getSubscription = (number: string) => async (dispatch, getState) => {
  const { checkUserAttribute } = await getState().rules.dataConfList.get(RulesKeys.GET_CONF);
  await dispatch({
    type: ACTION_TYPES.GET_SUBSCRIPTION_BY_NUMBER,
    payload: contractApi.getSubscriptionByNumber(number, checkUserAttribute),
  });
  const subscriptionResp = await getState().contract?.subscriptionModel?.subscriptionSelected;
  if (subscriptionResp === 'NOT_ACCESS') {
    window.location.href = '/contracts';
  }
};
export const recoverAndActiveSubscriptionsClients = () => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.RECOVER_ACTIVATE_SUBSCRIPTIONS,
    payload: contractApi.recoverAndActiveSubscriptionsClients(),
  });
};
